
import Framework from '@geek/yum-freight-framework'
import YunIcon from '@yld/yun-icon'
import './assets/element.scss'
import Vue from 'vue'
import { initProjectI18n } from './lang'

const serverConfig = require('../serverConfig.json')

initProjectI18n()

Vue.prototype.$eventBus = new Vue()
const app = new Framework({
  serverConfig
})

app.use(YunIcon)
app.start()
